/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_files_upload_file } from '../models/Body_files_upload_file';
import type { BrandFileRead } from '../models/BrandFileRead';
import type { CreativeList } from '../models/CreativeList';
import type { FileContent } from '../models/FileContent';
import type { FileList } from '../models/FileList';
import type { FileRename } from '../models/FileRename';
import type { NoteCreate } from '../models/NoteCreate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FilesService {
    /**
     * List Files
     * The brand's uploads and artifacts, newest first.
     * @param brandId
     * @returns FileList Successful Response
     * @throws ApiError
     */
    public static listFiles(
        brandId: number,
    ): CancelablePromise<FileList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Creatives
     * The brand's generated ads, newest first.
     * @param brandId
     * @returns CreativeList Successful Response
     * @throws ApiError
     */
    public static listCreatives(
        brandId: number,
    ): CancelablePromise<CreativeList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files/creatives',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload File
     * Add a file to Uploads. Gemini titles and describes it in the background.
     * @param brandId
     * @param formData
     * @returns BrandFileRead Successful Response
     * @throws ApiError
     */
    public static uploadFile(
        brandId: number,
        formData: Body_files_upload_file,
    ): CancelablePromise<BrandFileRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/files/upload',
            query: {
                'brand_id': brandId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Note
     * Add an empty markdown note to Uploads.
     * @param brandId
     * @param requestBody
     * @returns BrandFileRead Successful Response
     * @throws ApiError
     */
    public static createNote(
        brandId: number,
        requestBody: NoteCreate,
    ): CancelablePromise<BrandFileRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/files/notes',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read File Content
     * The text of a note or other text file.
     * @param fileId
     * @param brandId
     * @returns FileContent Successful Response
     * @throws ApiError
     */
    public static readFileContent(
        fileId: string,
        brandId: number,
    ): CancelablePromise<FileContent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files/{file_id}/content',
            path: {
                'file_id': fileId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save File Content
     * Save a note's text. Gemini rewrites its title and description in the background.
     * @param fileId
     * @param brandId
     * @param requestBody
     * @returns BrandFileRead Successful Response
     * @throws ApiError
     */
    public static saveFileContent(
        fileId: string,
        brandId: number,
        requestBody: FileContent,
    ): CancelablePromise<BrandFileRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/files/{file_id}/content',
            path: {
                'file_id': fileId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Rename File
     * @param fileId
     * @param brandId
     * @param requestBody
     * @returns BrandFileRead Successful Response
     * @throws ApiError
     */
    public static renameFile(
        fileId: string,
        brandId: number,
        requestBody: FileRename,
    ): CancelablePromise<BrandFileRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/files/{file_id}',
            path: {
                'file_id': fileId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete File
     * @param fileId
     * @param brandId
     * @returns void
     * @throws ApiError
     */
    public static deleteFile(
        fileId: string,
        brandId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/files/{file_id}',
            path: {
                'file_id': fileId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
